/**
   * @description constructs query needed for initial textSwitch component; captures resource type information and related 
   * details needed to allow the textSwitch component decide what kind of display is necessary
   * 
   * @param {string} resourceurl - resource url should be full scta url id
   * @returns {string} - returns query as string
   */
export const getStructureType = (resourceurl:string): string => {
  const query = [
    "SELECT DISTINCT ?type ?structureType ?level ?topLevel ?itemParent ?resourceTitle ?author ?authorTitle ?cmanifestation ?ctranscription ?cexpression",
    "WHERE { ",
    "<" + resourceurl + "> <http://www.w3.org/1999/02/22-rdf-syntax-ns#type> ?type . ",
    "OPTIONAL {",
      "<" + resourceurl + "> <http://www.loc.gov/loc.terms/relators/AUT> ?author .",
      "?author <http://purl.org/dc/elements/1.1/title> ?authorTitle .",
    "}",
    "OPTIONAL {",
      "<" + resourceurl + "> <http://purl.org/dc/elements/1.1/title> ?resourceTitle .",
    "}",
    "OPTIONAL {",
    "<" + resourceurl + "> <http://scta.info/property/structureType> ?structureType . ",
    "}",
    "OPTIONAL {",
    "<" + resourceurl + "> <http://scta.info/property/level> ?level . ",
    "}",
    "OPTIONAL {",
    "<" + resourceurl + "> <http://scta.info/property/isPartOfTopLevelExpression> ?topLevel . ",
    "}",
    "OPTIONAL {",
      "<" + resourceurl + "> <http://scta.info/property/isPartOfTopLevelManifestation> ?topLevel . ",
      //"?mtopLevel <http://scta.info/property/isManifestationOf> ?topLevel . ",
    "}",
    "OPTIONAL {",
      "<" + resourceurl + "> <http://scta.info/property/isPartOfTopLevelTranscription> ?topLevel . ",
      //"?ttopLevel <http://scta.info/property/isTranscriptionOf> ?mtopLevel . ",
      //"?mtopLevel <http://scta.info/property/isManifestationOf> ?topLevel . ",
    "}",
    "OPTIONAL {",
      "{",
        "<" + resourceurl + "> <http://scta.info/property/isPartOfStructureItem> ?itemParent . ",
      "}",
      "UNION",
      "{",
        "<" + resourceurl + "> <http://scta.info/property/isPartOfStructureBlock> ?blockParent . ",
        "?blockParent  <http://scta.info/property/isPartOfStructureItem> ?itemParent .",
      "}",
    "}",
    "OPTIONAL {",
      "{",
        "<" + resourceurl + "> <http://scta.info/property/hasCanonicalManifestation> ?cmanifestation . ",
        "?cmanifestation <http://scta.info/property/hasCanonicalTranscription> ?ctranscription . ",
        "BIND(<" + resourceurl + "> AS ?cexpression) .",
      "}",
      "UNION",
      "{",
        "<" + resourceurl + "> <http://scta.info/property/hasCanonicalTranscription> ?ctranscription . ",
        "<" + resourceurl + "> <http://scta.info/property/isManifestationOf> ?cexpression . ",
        "BIND(<" + resourceurl + "> AS ?cmanifestation) .",
      "}",
      "UNION",
      "{",
        // "<" + resourceurl + "> a <http://scta.info/resource/transcription> . ",
        "<" + resourceurl + "> <http://scta.info/property/isTranscriptionOf> ?cmanifestation . ",
        "?cmanifestation <http://scta.info/property/isManifestationOf> ?cexpression . ",
        "BIND(<" + resourceurl + "> AS ?ctranscription) .",
      "}",
    "}",
  "}"].join('');
    return query
  }

/**
   * @description constructs query needed for initial textSwitch component; captures resource type information and related 
   * details needed to allow the textSwitch component decide what kind of display is necessary
   * 
   * @param {string} resourceurl - resource url should be full scta url id
   * @returns {string} - returns query as string
   */
export const getStructureTypeAlt = (resourceurl:string): string => {
  const query = `
  SELECT DISTINCT 
?type ?resourceTitle ?structureType ?level ?author ?authorTitle ?cmanifestation ?ctranscription ?cexpression ?itemParent ?eItemParent ?mItemParent ?tItemParent ?eTopLevel ?mTopLevel ?tTopLevel
WHERE 
{ 
  <${resourceurl}> <http://www.w3.org/1999/02/22-rdf-syntax-ns#type> ?type . 
  OPTIONAL 
  {
    <${resourceurl}> <http://purl.org/dc/elements/1.1/title> ?resourceTitle .
  }
  OPTIONAL 
  {
    <${resourceurl}> <http://scta.info/property/structureType> ?structureType . 
    <${resourceurl}> <http://scta.info/property/level> ?level . 
    {
      <${resourceurl}> <http://scta.info/property/hasCanonicalManifestation> ?cmanifestation . 
      ?cmanifestation <http://scta.info/property/hasCanonicalTranscription> ?ctranscription . 
      BIND(<${resourceurl}> AS ?cexpression) .
    }
    UNION
    {
      <${resourceurl}> <http://scta.info/property/hasCanonicalTranscription> ?ctranscription .
      <${resourceurl}> <http://scta.info/property/isManifestationOf> ?cexpression . 
      BIND(<${resourceurl}> AS ?cmanifestation) .
    }
    UNION
    {
      <${resourceurl}> <http://scta.info/property/isTranscriptionOf> ?cmanifestation . 
      ?cmanifestation <http://scta.info/property/isManifestationOf> ?cexpression . 
      BIND(<${resourceurl}> AS ?ctranscription) .
    }
      {
      ?cexpression <http://scta.info/property/isPartOfTopLevelExpression> ?eTopLevel .
      ?cmanifestation <http://scta.info/property/isPartOfTopLevelManifestation> ?mTopLevel .
      ?ctranscription <http://scta.info/property/isPartOfTopLevelTranscription> ?tTopLevel .
      }
    UNION
    {
      ?cexpression <http://scta.info/property/level> '1' .
      BIND(?cexpression AS ?eTopLevel) .
      ?cmanifestation <http://scta.info/property/level> '1' .
      BIND(?cmanifestation AS ?mTopLevel) .
      ?ctranscription <http://scta.info/property/level> '1' .
      BIND(?ctranscription AS ?tTopLevel) .
    }
    {
    ?eTopLevel <http://www.loc.gov/loc.terms/relators/AUT> ?author .
    ?author <http://purl.org/dc/elements/1.1/title> ?authorTitle .
  }
  UNION
  {
    <${resourceurl}> <http://www.loc.gov/loc.terms/relators/AUT> ?author .
    ?author <http://purl.org/dc/elements/1.1/title> ?authorTitle .
  }
  }
  OPTIONAL 
  {
    {
      <${resourceurl}> <http://scta.info/property/isPartOfStructureItem> ?itemParent . 
    }
    UNION
    {
      <${resourceurl}> <http://scta.info/property/isPartOfStructureBlock> ?blockParent . 
      ?blockParent  <http://scta.info/property/isPartOfStructureItem> ?itemParent .
    }
    {
      ?itemParent <http://scta.info/property/hasCanonicalManifestation> ?mItemParent . 
      ?mItemParent <http://scta.info/property/hasCanonicalTranscription> ?tItemParent . 
      BIND(?itemParent AS ?eItemParent) .
    }
    UNION
    {
      ?itemParent <http://scta.info/property/hasCanonicalTranscription> ?tItemParent . 
      ?itemParent <http://scta.info/property/isManifestationOf> ?eItemParent . 
      BIND(?itemParent AS ?mItemParent) .
    }
    UNION
    {
      ?itemParent <http://scta.info/property/isTranscriptionOf> ?mItemParent . 
      ?mItemParent <http://scta.info/property/isManifestationOf> ?eItemParent . 
      BIND(?itemParent AS ?tItemParent).
    }
  }
  
}`
    return query
  }

  export const getStructureTypeAlt2 = (resourceurl:string): string => {
  const query = `
    SELECT DISTINCT 
    ?type ?resourceTitle ?structureType ?level ?author ?authorTitle
    WHERE 
    { 
      <${resourceurl}> <http://www.w3.org/1999/02/22-rdf-syntax-ns#type> ?type . 
      OPTIONAL 
      {
        <${resourceurl}> <http://purl.org/dc/elements/1.1/title> ?resourceTitle .
      }
      OPTIONAL 
      {
        <${resourceurl}> <http://scta.info/property/structureType> ?structureType . 
      }
      OPTIONAL{
        <${resourceurl}> <http://scta.info/property/level> ?level . 
      }
  }`
  return query
  }
  
  export const getTopLevelExpressionInfo = (resourceurl:string): string => {
    const query = `
    SELECT DISTINCT ?cmanifestation ?ctranscription ?cexpression ?author ?authorTitle
      WHERE{
      <${resourceurl}> <http://scta.info/property/hasCanonicalManifestation> ?cmanifestation . 
      ?cmanifestation <http://scta.info/property/hasCanonicalTranscription> ?ctranscription . 
      BIND(<${resourceurl}> AS ?cexpression) .
      OPTIONAL{
      <${resourceurl}> <http://www.loc.gov/loc.terms/relators/AUT> ?author .
      ?author <http://purl.org/dc/elements/1.1/title> ?authorTitle .
      }
    }`
    return query
  }
  export const getTopLevelManifestationInfo = (resourceurl:string): string => {
    const query = `
    SELECT DISTINCT ?cmanifestation ?ctranscription ?cexpression ?author ?authorTitle
      WHERE{
      <${resourceurl}> <http://scta.info/property/hasCanonicalTranscription> ?ctranscription .
      <${resourceurl}> <http://scta.info/property/isManifestationOf> ?cexpression . 
      BIND(<${resourceurl}> AS ?cmanifestation) .
      OPTIONAL{
      ?cexpression <http://www.loc.gov/loc.terms/relators/AUT> ?author .
      ?author <http://purl.org/dc/elements/1.1/title> ?authorTitle .
      }
    }`
    return query
  }
  export const getTopLevelTranscriptionInfo = (resourceurl:string): string => {
    const query = `
    SELECT DISTINCT ?cmanifestation ?ctranscription ?cexpression ?author ?authorTitle
      WHERE{
      <${resourceurl}> <http://scta.info/property/isTranscriptionOf> ?cmanifestation . 
      ?cmanifestation <http://scta.info/property/isManifestationOf> ?cexpression . 
      BIND(<${resourceurl}> AS ?ctranscription) .
      OPTIONAL{
      ?cexpression <http://www.loc.gov/loc.terms/relators/AUT> ?author .
      ?author <http://purl.org/dc/elements/1.1/title> ?authorTitle .
      }
    }`
    return query
  }
  
  // this query also used for non top level div collections
  export const getItemExpressionInfo = (resourceurl:string): string => {
    const query = `
    SELECT DISTINCT ?cmanifestation ?ctranscription ?cexpression ?eTopLevel ?mTopLevel ?tTopLevel ?author ?authorTitle ?docSource
      WHERE{
      <${resourceurl}> <http://scta.info/property/hasCanonicalManifestation> ?cmanifestation . 
      ?cmanifestation <http://scta.info/property/hasCanonicalTranscription> ?ctranscription . 
      OPTIONAL{
        ?ctranscription <http://scta.info/property/hasDocument> ?docSource .
      }
      BIND(<${resourceurl}> AS ?cexpression) .
      ?cexpression <http://scta.info/property/isPartOfTopLevelExpression> ?eTopLevel .
      ?cmanifestation <http://scta.info/property/isPartOfTopLevelManifestation> ?mTopLevel .
      ?ctranscription <http://scta.info/property/isPartOfTopLevelTranscription> ?tTopLevel .
      OPTIONAL{
      ?eTopLevel <http://www.loc.gov/loc.terms/relators/AUT> ?author .
      ?author <http://purl.org/dc/elements/1.1/title> ?authorTitle .
      }
    }`
    return query
  }
  // this query also used for non top level div collections
  export const getItemManifestationInfo = (resourceurl:string): string => {
    const query = `
    SELECT DISTINCT ?cmanifestation ?ctranscription ?cexpression ?eTopLevel ?mTopLevel ?tTopLevel ?author ?authorTitle ?docSource
      WHERE {
      <${resourceurl}> <http://scta.info/property/hasCanonicalTranscription> ?ctranscription .
      OPTIONAL{
        ?ctranscription <http://scta.info/property/hasDocument> ?docSource .
      }
      <${resourceurl}> <http://scta.info/property/isManifestationOf> ?cexpression . 
      BIND(<${resourceurl}> AS ?cmanifestation) .
      ?cexpression <http://scta.info/property/isPartOfTopLevelExpression> ?eTopLevel .
      ?cmanifestation <http://scta.info/property/isPartOfTopLevelManifestation> ?mTopLevel .
      ?ctranscription <http://scta.info/property/isPartOfTopLevelTranscription> ?tTopLevel .
      OPTIONAL{
      ?eTopLevel <http://www.loc.gov/loc.terms/relators/AUT> ?author .
      ?author <http://purl.org/dc/elements/1.1/title> ?authorTitle .
      }
    }`
    return query
  }

  // this query also used for non top level div collections
  export const getItemTranscriptionInfo = (resourceurl:string): string => {
    const query = `
    SELECT DISTINCT ?cmanifestation ?ctranscription ?cexpression ?eTopLevel ?mTopLevel ?tTopLevel ?author ?authorTitle ?docSource 
      WHERE {
      <${resourceurl}> <http://scta.info/property/isTranscriptionOf> ?cmanifestation . 
      ?cmanifestation <http://scta.info/property/isManifestationOf> ?cexpression . 
      BIND(<${resourceurl}> AS ?ctranscription) .
      OPTIONAL{
        ?ctranscription <http://scta.info/property/hasDocument> ?docSource .
      }
      ?cexpression <http://scta.info/property/isPartOfTopLevelExpression> ?eTopLevel .
      ?cmanifestation <http://scta.info/property/isPartOfTopLevelManifestation> ?mTopLevel .
      ?ctranscription <http://scta.info/property/isPartOfTopLevelTranscription> ?tTopLevel .
      OPTIONAL{
      ?eTopLevel <http://www.loc.gov/loc.terms/relators/AUT> ?author .
      ?author <http://purl.org/dc/elements/1.1/title> ?authorTitle .
      }
    }`
    return query
  }
  export const getDivAndBelowExpressionInfo = (resourceurl:string): string => {
    const query = `
    SELECT DISTINCT ?cmanifestation ?ctranscription ?cexpression ?eTopLevel ?mTopLevel ?tTopLevel ?author ?authorTitle ?eItemParent ?mItemParent ?tItemParent ?docSource 
      WHERE{
      <${resourceurl}> <http://scta.info/property/hasCanonicalManifestation> ?cmanifestation . 
      ?cmanifestation <http://scta.info/property/hasCanonicalTranscription> ?ctranscription . 
      OPTIONAL{
        ?ctranscription <http://scta.info/property/hasDocument> ?docSource .
      }
      BIND(<${resourceurl}> AS ?cexpression) .
      ?cexpression <http://scta.info/property/isPartOfTopLevelExpression> ?eTopLevel .
      ?cmanifestation <http://scta.info/property/isPartOfTopLevelManifestation> ?mTopLevel .
      ?ctranscription <http://scta.info/property/isPartOfTopLevelTranscription> ?tTopLevel .
      OPTIONAL{
      ?eTopLevel <http://www.loc.gov/loc.terms/relators/AUT> ?author .
      ?author <http://purl.org/dc/elements/1.1/title> ?authorTitle .
      }
      {
      <${resourceurl}> <http://scta.info/property/isPartOfStructureItem> ?eItemParent . 
      }
      UNION
      {
      <${resourceurl}> <http://scta.info/property/isPartOfStructureBlock> ?blockParent . 
      ?blockParent  <http://scta.info/property/isPartOfStructureItem> ?eItemParent .
      }
      ?eItemParent <http://scta.info/property/hasCanonicalManifestation> ?mItemParent . 
      ?mItemParent <http://scta.info/property/hasCanonicalTranscription> ?tItemParent . 
    }`
    return query
  }
  export const getDivAndBelowManifestationInfo = (resourceurl:string): string => {
    const query = `
    SELECT DISTINCT ?cmanifestation ?ctranscription ?cexpression ?eTopLevel ?mTopLevel ?tTopLevel ?author ?authorTitle ?eItemParent ?mItemParent ?tItemParent ?docSource
      WHERE{
      <${resourceurl}> <http://scta.info/property/hasCanonicalTranscription> ?ctranscription .
      OPTIONAL{
        ?ctranscription <http://scta.info/property/hasDocument> ?docSource .
      }
      <${resourceurl}> <http://scta.info/property/isManifestationOf> ?cexpression . 
      BIND(<${resourceurl}> AS ?cmanifestation) .
      ?cexpression <http://scta.info/property/isPartOfTopLevelExpression> ?eTopLevel .
      ?cmanifestation <http://scta.info/property/isPartOfTopLevelManifestation> ?mTopLevel .
      ?ctranscription <http://scta.info/property/isPartOfTopLevelTranscription> ?tTopLevel .
      OPTIONAL{
      ?eTopLevel <http://www.loc.gov/loc.terms/relators/AUT> ?author .
      ?author <http://purl.org/dc/elements/1.1/title> ?authorTitle .
      }
      {
      <${resourceurl}> <http://scta.info/property/isPartOfStructureItem> ?mItemParent . 
      }
      UNION
      {
      <${resourceurl}> <http://scta.info/property/isPartOfStructureBlock> ?blockParent . 
      ?blockParent  <http://scta.info/property/isPartOfStructureItem> ?mItemParent .
      }
      ?mItemParent <http://scta.info/property/isManifestationOf> ?eItemParent . 
      ?mItemParent <http://scta.info/property/hasCanonicalTranscription> ?tItemParent . 
    }`
    return query
  }

  export const getDivAndBelowTranscriptionInfo = (resourceurl:string): string => {
    const query = `
    SELECT DISTINCT ?cmanifestation ?ctranscription ?cexpression ?eTopLevel ?mTopLevel ?tTopLevel ?author ?authorTitle ?eItemParent ?mItemParent ?tItemParent ?docSource 
      WHERE{
      <${resourceurl}> <http://scta.info/property/isTranscriptionOf> ?cmanifestation . 
      ?cmanifestation <http://scta.info/property/isManifestationOf> ?cexpression . 
      BIND(<${resourceurl}> AS ?ctranscription) .
      OPTIONAL{
        ?ctranscription <http://scta.info/property/hasDocument> ?docSource .
      }
      ?cexpression <http://scta.info/property/isPartOfTopLevelExpression> ?eTopLevel .
      ?cmanifestation <http://scta.info/property/isPartOfTopLevelManifestation> ?mTopLevel .
      ?ctranscription <http://scta.info/property/isPartOfTopLevelTranscription> ?tTopLevel .
      OPTIONAL{
      ?eTopLevel <http://www.loc.gov/loc.terms/relators/AUT> ?author .
      ?author <http://purl.org/dc/elements/1.1/title> ?authorTitle .
      }
      {
      <${resourceurl}> <http://scta.info/property/isPartOfStructureItem> ?tItemParent . 
      }
      UNION
      {
      <${resourceurl}> <http://scta.info/property/isPartOfStructureBlock> ?blockParent . 
      ?blockParent  <http://scta.info/property/isPartOfStructureItem> ?tItemParent .
      }
      ?tItemParent <http://scta.info/property/isTranscriptionOf> ?mItemParent . 
      ?mItemParent <http://scta.info/property/isManifestationOf> ?eItemParent . 
    }`
    return query
  }
  // this query is primarily used when a quote or ref is clicked and 
  // we want to look up the source information 
  export const getSourcesInfo = (resourceurl:string): string => {
    const query = `
    SELECT DISTINCT ?cmanifestation ?ctranscription ?cexpression ?eTopLevel ?mTopLevel ?tTopLevel ?author ?authorTitle ?eItemParent ?mItemParent ?tItemParent ?isReferenceTo ?rangeStart ?rangeEnd ?structureType ?level ?longTitle
      WHERE{
      {
      <${resourceurl}> <http://scta.info/property/source> ?source .
      }
      UNION
      {
      <${resourceurl}> <http://scta.info/property/source> ?bn . 
      ?bn <http://scta.info/property/source> ?source .
      ?bn <http://scta.info/property/canonicalRangeStart> ?rangeStart .
      ?bn <http://scta.info/property/canonicalRangeEnd> ?rangeEnd .
      } 
      OPTIONAL{
      <${resourceurl}> <http://scta.info/property/isReferenceTo> ?isReferenceTo .
      }
      OPTIONAL{
        ?isReferenceTo <http://scta.info/property/isReferenceTo> <${resourceurl}> .
        }
      OPTIONAL{
      ?source <http://scta.info/property/longTitle> ?longTitle. 
      }
      ?source <http://scta.info/property/structureType> ?structureType .
      ?source <http://scta.info/property/level> ?level .
      ?source <http://scta.info/property/hasCanonicalManifestation> ?cmanifestation . 
      ?cmanifestation <http://scta.info/property/hasCanonicalTranscription> ?ctranscription . 
      BIND(?source AS ?cexpression) .
      ?cexpression <http://scta.info/property/isPartOfTopLevelExpression> ?eTopLevel .
      ?cmanifestation <http://scta.info/property/isPartOfTopLevelManifestation> ?mTopLevel .
      ?ctranscription <http://scta.info/property/isPartOfTopLevelTranscription> ?tTopLevel .
      OPTIONAL{
      ?eTopLevel <http://www.loc.gov/loc.terms/relators/AUT> ?author .
      ?author <http://purl.org/dc/elements/1.1/title> ?authorTitle .
      }
      OPTIONAL{
        {
        ?source <http://scta.info/property/isPartOfStructureItem> ?eItemParent . 
        }
        UNION
        {
        ?source <http://scta.info/property/isPartOfStructureBlock> ?blockParent . 
        ?blockParent  <http://scta.info/property/isPartOfStructureItem> ?eItemParent .
        }
        ?eItemParent <http://scta.info/property/hasCanonicalManifestation> ?mItemParent . 
        ?mItemParent <http://scta.info/property/hasCanonicalTranscription> ?tItemParent . 
      }
    }`
    return query
  }


 export const getModernCitation = (resourceurl:string): string => {
    const query = `
    SELECT DISTINCT ?modernCitation ?isReferenceTo
      WHERE{
      <${resourceurl}> a ?type .
      OPTIONAL{
        <${resourceurl}> <http://scta.info/property/citation> ?modernCitation .
      }
      OPTIONAL{
        <${resourceurl}> <http://scta.info/property/isReferenceTo> ?isReferenceTo .
        }
      OPTIONAL{
        ?isReferenceTo <http://scta.info/property/isReferenceTo> <${resourceurl}> .
        }
    }`
    return query
  }




  //TODO check if this is used; if not, delete it
  export const getItemTranscriptionFromBlockDiv = (resourceurl: string): string => {
    const query = [
      "SELECT DISTINCT ?ctranscription ?blockDivExpression ",
      "WHERE { ",
        "OPTIONAL",
        "{",
          //"<" + resourceurl + "> <http://scta.info/property/isPartOfStructureItem> ?itemParent . ",
          //"<" + resourceurl + "> <http://scta.info/property/isMemberOf> ?itemParent . ",
          "{",
            "<" + resourceurl + "> <http://scta.info/property/isPartOfStructureItem> ?itemParent . ",
          "}",
          "UNION",
          "{",
            "<" + resourceurl + ">  <http://scta.info/property/isPartOfStructureBlock> ?blockParent .",
            "?blockParent <http://scta.info/property/isPartOfStructureItem> ?itemParent . ",
          "}",

          "?itemParent <http://scta.info/property/structureType> <http://scta.info/resource/structureItem> . ",
          "{",
            "{",
              "?itemParent <http://scta.info/property/hasCanonicalManifestation> ?cmanifestation . ",
              "?cmanifestation <http://scta.info/property/hasCanonicalTranscription> ?ctranscription . ",
            "}",
            "UNION",
            "{",
              "?itemParent <http://scta.info/property/hasCanonicalTranscription> ?ctranscription . ",
            "}",
          "}",
          "}",
          "OPTIONAL",
          "{",
            "{",
              "<" + resourceurl + "> <http://scta.info/property/isManifestationOf> ?blockDivExpression . ",
            "}",
            "UNION",
            "{",
              "<" + resourceurl + "> <http://scta.info/property/isTranscriptionOf> ?blockDivManifestation . ",
              "?blockDivManifestation <http://scta.info/property/isManifestationOf> ?blockDivExpression . ",
            "}",
          "}",
        "}"].join('');
      return query
  }
  
  export const getArticleTranscriptionDoc = (resourceurl: string) => {
    const query = [
      "SELECT DISTINCT ?doc ?articleType ",
      "WHERE { ",
        "<" + resourceurl + "> <http://scta.info/property/hasCanonicalTranscription> ?ctranscription . ",
        "<" + resourceurl + "> <http://scta.info/property/articleType> ?articleType .",
        "?ctranscription <http://scta.info/property/hasXML> ?doc . ",
      "}"].join('');
      return query
    }